import { createRouter } from '@blocks/base/router';

export default createRouter({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      component: () => import('../views/Index'),
      meta: {
        level: 2,
      },
    },
    // 新增路由加在这里
    {
      path: '/rule',
      component: () => import('../views/Rule'),
      meta: {
        level: 3,
      },
    },
    {
      path: '/my',
      component: () => import('../views/My'),
    },
    {
      path: '/my',
      component: () => import('../views/My'),
    },
    {
      path: '/article',
      component: () => import('../views/Article'),
    },
    {
      path: '*',
      redirect: '/index',
    },
  ],
});
